<template>
    <BasicHeader
        :is-text-logo="isTextLogo"
        :has-logo-navigation="false"
        :rwd="true"
        class="max-h-[175px] overflow-auto"
        size="s"
    >
        <template
            v-if="slots.title"
            #title
        >
            <slot name="title"> </slot>
        </template>
        <template #default>
            <slot></slot>
        </template>
    </BasicHeader>
</template>

<script setup lang="ts">
import BasicHeader from '@molecules/BasicHeader/BasicHeader.vue';

import { useSetBodyClass } from '@composables/useSetBodyClass';
import type {
    BasicHeaderProps,
    BasicHeaderSlots,
} from '@molecules/BasicHeader/BasicHeader.vue';

defineProps<BasicHeaderProps>();

const slots = defineSlots<BasicHeaderSlots>();

useSetBodyClass(['overflow-hidden']);
</script>
